import React from "react";
import { renderMetaTags } from "react-datocms";
import { Helmet } from "react-helmet";
import {useQuery} from "graphql-hooks";

// build query for client favicon from CMS
const CMS_QUERY = `query datoQuery {
    _site {
        faviconMetaTags(variants: [icon, appleTouchIcon, msApplication]) {
            attributes
            tag
        }
    }
}`;

export const Favicon = () => {
    // init query CMS for favicon
    const { loading, error, data } = useQuery(CMS_QUERY);

    // check to see if favicon is [has errors/is still loading], revert to default
    if ( !error && !loading && data && data._site && data._site.faviconMetaTags && data._site.faviconMetaTags.length > 0 ) {
        return (
            <Helmet>
                {renderMetaTags(data._site.faviconMetaTags)}
            </Helmet>
        );
    }
    else {
        // This fires off if there is an error or if query is still loading or if a favicon image isn't set in CMS.
        return (
            <></>
        );
    }
}
